module.exports = __webpack_public_path__ + "img/develop.d22fecea.jpg";